import { render } from "./PrivatePage.vue?vue&type=template&id=aceec086"
import script from "./PrivatePage.vue?vue&type=script&lang=js"
export * from "./PrivatePage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/giulio/Documents/Sviluppo/chen/categoria/test-pwa-serverless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__